import VueI18n from "vue-i18n";
import Vue from 'vue'
import hk from "../lang/hk";
import cn from "../lang/cn";
import en from "../lang/en";

Vue.use(VueI18n)
const i18n = new VueI18n({
  /*this.$i18n.locale 通过切换locale的值来实现语言切换*/
  locale: localStorage.getItem("language") ? localStorage.getItem("language") : "zh-TW",    // 语言标识,
  /* fallbackLocale: 'zh-CN',//没有英文的时候默认中文语言
     silentFallbackWarn: true,//抑制警告
    zh-CN,zh-TW,en*/
  messages: {
    'zh-TW': hk,  /*繁体*/
    'zh-CN': cn,  /*中文语言包*/
    'en': en,  /*英文语言包*/
  },
});

export default  i18n



// WEBPACK FOOTER //
// ./src/utils/i18n.js